import { Button, Card, Col, Form, Input, Row, Typography } from "antd";
import styles from "./AddProdCat.module.css";

import { Fragment, useState, useEffect } from "react";

import { useDispatch } from "react-redux";
import { addProductCategory } from "../../redux/actions/productCategory/addProductCategoryAciton";
import UploadProductCategoryExcel from "./UploadProductCategoryExcel";

const AddProductCategory = ({ prefillText = "", onSuccess = null, inModal = false, onCancel = null }) => {
	const dispatch = useDispatch();
	const { Title } = Typography;

	const [form] = Form.useForm();

	const [loading, setLoading] = useState(false);

	// Prefill the form when prefillText is provided
	useEffect(() => {
		if (prefillText) {
			form.setFieldsValue({
				name: prefillText
			});
		}
	}, [prefillText, form]);

	const onClick = () => {
		setLoading(true);
	};

	const onFinish = async (values) => {
		try {
			const resp = await dispatch(addProductCategory(values));
			if (resp.message === "success") {
				setLoading(false);
				form.resetFields();
				if (onSuccess) onSuccess();
			} else {
				setLoading(false);
			}
		} catch (error) {
			setLoading(false);
			console.log(error.message);
		}
	};

	const onFinishFailed = (errorInfo) => {
		setLoading(false);
		console.log("Failed:", errorInfo);
	};

	const formContent = (
		<Form
			form={form}
			className=''
			name='basic'
			labelCol={{ span: inModal ? 6 : 7 }}
			wrapperCol={{ span: inModal ? 18 : 16 }}
			initialValues={{ remember: true }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
			autoComplete='off'
		>
			<Form.Item
				style={{ marginBottom: "10px" }}
				label='Name'
				name='name'
				rules={[{ required: true, message: "Please input category name!" }]}
			>
				<Input />
			</Form.Item>
			<Form.Item
				style={{ marginBottom: inModal ? 0 : "10px" }}
				className={!inModal ? styles.addProdCatBtnContainer : undefined}
				wrapperCol={inModal ? { offset: 6, span: 18 } : undefined}
			>
				{inModal ? (
					<div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
						<Button
							loading={loading}
							onClick={onClick}
							htmlType='submit'
							shape='round'
							style={{ backgroundColor: "#52c41a", borderColor: "#52c41a", color: "#fff" }}
						>
							Add Category
						</Button>
						{onCancel && (
							<Button type="primary" danger shape="round" onClick={onCancel}>
								Cancel
							</Button>
						)}
					</div>
				) : (
					<Button loading={loading} onClick={onClick} type='primary' htmlType='submit' shape='round'>
						Add Category
					</Button>
				)}
			</Form.Item>
		</Form>
	);

	if (inModal) {
		return formContent;
	}

	return (
		<Fragment>
			<Row className='mr-top' justify='space-between' gutter={[0, 30]}>
				<Col xs={24} sm={24} md={24} lg={11} xl={11} className='rounded column-design'>
					<Card bordered={false} className='criclebox h-full'>
						<Title level={4} className="text-center" style={{ margin: '0 !important' }}>
							Add Product Category
						</Title>
						{formContent}
					</Card>
				</Col>
				<Col xs={24} sm={24} md={24} lg={11} xl={11} className='rounded column-design'>
					<Card bordered={false} className={styles.importCsvCard}>
						<Title level={4} className='m-2 text-center'>Import From Excel</Title>
						<UploadProductCategoryExcel onSuccess={onSuccess} />
					</Card>
				</Col>
			</Row>
		</Fragment>
	);
};

export default AddProductCategory;
